define('views/modules/setting/business/list/invoice-history-list',[
    // Libs
    'underscore', 'backbone',
    // views
    'views/parts/list/list',
    'views/modules/setting/business/list/invoice-history-list-item'
], function(
    // Libs
    _, Backbone,
    // views
    VList,
    VInvoiceHistoryListItem
) {

    var VInvoiceHistoryList = VList.extend({
        item: VInvoiceHistoryListItem,
        initialize: function(options) {
            this.options = options || {};
        },
    });

    return VInvoiceHistoryList;

});

